import { BiCart, BiCodeAlt, BiMobile, BiSolidPaintRoll, BiSolidServer } from 'react-icons/bi';
import { AiOutlineFundProjectionScreen } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const SERVICES = [
  { icon: BiSolidPaintRoll, titleKey: 'services_title1', descKey: 'services_desc1' },
  { icon: BiMobile, titleKey: 'services_title2', descKey: 'services_desc2' },
  { icon: BiCodeAlt, titleKey: 'services_title3', descKey: 'services_desc3' },
  { icon: AiOutlineFundProjectionScreen, titleKey: 'services_title4', descKey: 'services_desc4' },
  { icon: BiCart, titleKey: 'services_title5', descKey: 'services_desc5' },
  { icon: BiSolidServer, titleKey: 'services_title6', descKey: 'services_desc6' },
];

const ServicesSection = () => {
  const { t } = useTranslation();

  return (
    <section id="what-we-do" className="features section services-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title services-section__title">
              <h3 className="animate-on-scroll zoom-in" data-delay="100">{t('all_services')}</h3>
              <h2 className="animate-on-scroll fade-up" data-delay="200">{t('what_we_do')}</h2>
            </div>
          </div>
        </div>
        <div className="row services-grid">
          {SERVICES.map((service, index) => {
            const Icon = service.icon;
            return (
              <div key={service.titleKey} className="col-lg-4 col-md-6 col-12">
                <article
                  className="services-card animate-on-scroll fade-up"
                  data-delay={String((index + 1) * 100)}
                >
                  <span className="services-card__index" aria-hidden="true">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="services-card__icon">
                    <Icon />
                  </div>
                  <h3>{t(service.titleKey)}</h3>
                  <p>{t(service.descKey)}</p>
                  <span className="services-card__shine" aria-hidden="true" />
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
